export default "__VITE_ASSET__vZdmM8Qv__"